const EMAIL_REGEX = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

const FREE_EMAIL_DOMAINS = [
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.co.uk",
  "yahoo.fr",
  "yahoo.de",
  "yahoo.es",
  "yahoo.it",
  "yahoo.co.jp",
  "yahoo.com.au",
  "yahoo.com.br",
  "yahoo.ca",
  "hotmail.com",
  "hotmail.co.uk",
  "hotmail.fr",
  "hotmail.de",
  "hotmail.es",
  "hotmail.it",
  "hotmail.com.tr",
  "outlook.com",
  "outlook.co.uk",
  "outlook.de",
  "live.com",
  "live.co.uk",
  "msn.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "aol.com",
  "zoho.com",
  "protonmail.com",
  "protonmail.ch",
  "proton.me",
  "pm.me",
  "tutanota.com",
  "tutanota.de",
  "tutamail.com",
  "fastmail.com",
  "hey.com",
  "yandex.com",
  "yandex.ru",
  "yandex.com.tr",
  "yandex.kz",
  "mail.ru",
  "bk.ru",
  "list.ru",
  "inbox.ru",
  "rambler.ru",
  "qq.com",
  "163.com",
  "126.com",
  "naver.com",
  "daum.net",
  "web.de",
  "gmx.de",
  "gmx.com",
  "gmx.net",
  "mail.com",
  "mailinator.com",
  "tempmail.com",
  "temp-mail.org",
  "10minutemail.com",
  "guerrillamail.com",
  "yopmail.com",
  "throwawaymail.com",
  "trashmail.com",
  "maildrop.cc",
  "dispostable.com",
  "rocketmail.com",
];

function getEmailDomain(value) {
  if (typeof value !== "string") return null;
  const normalized = normalizeEmail(value);
  if (!normalized) return null;
  const atIndex = normalized.lastIndexOf("@");
  if (atIndex === -1) return null;
  return normalized.slice(atIndex + 1);
}

export function normalizeEmail(value) {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  return trimmed.toLowerCase();
}

export function isEmailFormatValid(value) {
  if (typeof value !== "string") return false;
  return EMAIL_REGEX.test(value.trim());
}

export function isFreeEmailDomain(value) {
  const domain = getEmailDomain(value);
  if (!domain) return false;
  return FREE_EMAIL_DOMAINS.some((blocked) => domain === blocked || domain.endsWith(`.${blocked}`));
}

export function getEmailError(value) {
  return isEmailFormatValid(value) ? null : "invalid_email";
}

export function getBusinessEmailError(value) {
  if (!isEmailFormatValid(value)) return "invalid_email";
  return isFreeEmailDomain(value) ? "free_email" : null;
}

export { FREE_EMAIL_DOMAINS };
